export const LANGUAGES = [
	{
		name: 'french',
		langCode: 'fr',
		img: 'https://d2lxkizvrhu4im.cloudfront.net/icons/flag-of-france-round.svg',
	},
	{
		name: 'english',
		langCode: 'en',
		img: 'https://d2lxkizvrhu4im.cloudfront.net/icons/flag-of-uk-round.svg',
	},
	{
		name: 'spanish',
		langCode: 'es',
		img: 'https://d2lxkizvrhu4im.cloudfront.net/icons/flag-of-spain-round.svg',
	},
	{
		name: 'italian',
		langCode: 'it',
		img: 'https://d2lxkizvrhu4im.cloudfront.net/icons/flag-of-italy-round.svg',
	},
	{
		name: 'portuguese_brazil',
		langCode: 'pt',
		img: 'https://d2lxkizvrhu4im.cloudfront.net/icons/flag-of-brazil-round.svg',
	},
	{
		name: 'german',
		langCode: 'de',
		img: 'https://d2lxkizvrhu4im.cloudfront.net/icons/flag-of-germany-round.svg',
	},
	{
		name: 'dutch',
		langCode: 'nl',
		img: 'https://d2lxkizvrhu4im.cloudfront.net/icons/flag-of-netherlands-round.svg',
	},
	{
		name: 'welsh',
		langCode: 'cy',
		img: 'https://mereos-corder.s3.eu-west-3.amazonaws.com/library_icons/flag-of-whales-round.svg',
	},
];

export const getLanguageByCode = (langCode) => {
	const baseLang = langCode?.split('-')[0];
	return LANGUAGES.find((language) => language.langCode === baseLang) || LANGUAGES[1];
};

export const saveSelectedLanguage = (language) => {
	try {
		localStorage.setItem('selectedLanguage', JSON.stringify(language));
	} catch (error) {
		console.error('Failed to save language preference:', error);
	}
};
